module.exports = __webpack_public_path__ + "media/theme/tutorial__dmm--3--create-a31d8d05.png";